import { render, staticRenderFns } from "./SaleChance.vue?vue&type=template&id=3274da32"
import script from "./SaleChance.vue?vue&type=script&lang=js"
export * from "./SaleChance.vue?vue&type=script&lang=js"
import style0 from "./SaleChance.vue?vue&type=style&index=0&id=3274da32&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports